import { Component, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseTunnelObject } from '../../model/base-tunnel-object';
import { CONFIG_CONTEXT } from '../../../../enum/config-context.enum';
import { KitchenFundingComponent } from '../../kitchen/kitchen-funding/kitchen-funding.component';
import { StorageFundingComponent } from '../../storage/storage-funding/storage-funding.component';
import { BathroomTunnelFundingComponent } from '../../bathroom/bathroom-tunnel-funding/bathroom-tunnel-funding.component';
import { BathroomHbmTunnelFundingComponent } from '../../bathroom-hbm/bathroom-hbm-tunnel-funding/bathroom-hbm-tunnel-funding.component';
import { CarpentryTunnelFundingComponent } from '../../carpentry/carpentry-tunnel-funding/carpentry-tunnel-funding.component';

@Component({
  selector: 'ng-casto-base-funding',
  templateUrl: './base-funding.component.html',
})
export class BaseFundingComponent extends BaseTunnelObject {
  private static readonly DEFAULT_PLACEHOLDER_IMAGE_SRC = 'assets/img/models/ash_gris.jpg';
  protected placeholderImageSrc: string = BaseFundingComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;

  @ViewChild('fundingContainer', { read: ViewContainerRef, static: true })
  private fundingContainer!: ViewContainerRef;

  protected subscribeToObservable() {
    this.subscriptionList.push(
      this.tunnelNavigationStore.getCurrentStep().subscribe(step => {
        if (step) {
          this.placeholderImageSrc = step.placeholderImageSrc ?? BaseFundingComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;
        }
      }),
      this.tunnelNavigationStore.getCurrentContext().subscribe(context => {
        if (context) {
          this.initBodyContentFromContext(context);
          this.context = context;
        }
      })
    );
  }

  // @ts-ignore
  private initBodyContentFromContext(context: CONFIG_CONTEXT) {
    switch (context) {
      case CONFIG_CONTEXT.KITCHEN:
        this.loadComponent(KitchenFundingComponent);
        break;
      case CONFIG_CONTEXT.STORAGE:
        this.loadComponent(StorageFundingComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM_V2:
        this.loadComponent(BathroomTunnelFundingComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM:
        this.loadComponent(BathroomHbmTunnelFundingComponent);
        break;
      case CONFIG_CONTEXT.CARPENTRY:
        this.loadComponent(CarpentryTunnelFundingComponent);
        break;
      default:
        break;
    }
  }

  private loadComponent(component: Type<any>): void {
    this.fundingContainer.clear();
    this.fundingContainer.createComponent(component);
  }
  context: CONFIG_CONTEXT;
  protected readonly CONFIG_CONTEXT = CONFIG_CONTEXT;

  more() {
    window.open('https://www.castorama.fr/avantages-carte-castorama/la-carte-de-credit-castorama', '_blank');
  }
}
